<app-wizard-step-wrapper
  [showStep]="showStep"
  [stepTitle]="stepMetadata.stepName"
  [formGroup]="formStep"
  >
  @if ((this.multiFactorInProgress$ | async) === false) {
    <app-multi-factor-challenge-options
      [user]="this.latestPackegeUser$ | async"
    ></app-multi-factor-challenge-options>
  }

  @if (this.multiFactorInProgress$ | async) {
    <app-multi-factor-challenge-security-code
      [formGroup]="formStep"
      [user]="this.latestPackegeUser$ | async"
      >
    </app-multi-factor-challenge-security-code>
  }
</app-wizard-step-wrapper>
